import { omit } from "lodash-es";

export const CastingTeam = {
  NONE: "NENHUM",
  BABY: "BABY",
  VOGUE: "VOGUE",
  YOUNIQUE: "YOUNIQUE",
  EVENTS_SAO_PAULO: "EVENTOS_SAO_PAULO",
  SELECTIVE_EVENTS: "EVENTOS_SELETIVAS",
} as const;

export type CastingTeam = (typeof CastingTeam)[keyof typeof CastingTeam];

export const CastingTeamTranslate: Record<CastingTeam, string> = {
  [CastingTeam.NONE]: "Nenhum",
  [CastingTeam.BABY]: "Baby",
  [CastingTeam.VOGUE]: "Vogue",
  [CastingTeam.YOUNIQUE]: "Younique",
  [CastingTeam.EVENTS_SAO_PAULO]: "Eventos São Paulo",
  [CastingTeam.SELECTIVE_EVENTS]: "Eventos seletivas",
};

export enum JobStagesEnum {
  CASTING = "CASTING",
  PRE_SELECTION = "PRE_SELECTION",
  EDITED = "EDITED",
  APPROVED = "APPROVAL",
}

export const JobStagesTranslateToSlug: Record<JobStagesEnum, string> = {
  [JobStagesEnum.CASTING]: "casting",
  [JobStagesEnum.PRE_SELECTION]: "pre-selecao",
  [JobStagesEnum.EDITED]: "editados",
  [JobStagesEnum.APPROVED]: "aprovados",
};

export const JobStagesSlugToEnum: Record<string, JobStagesEnum> = {
  casting: JobStagesEnum.CASTING,
  "pre-selecao": JobStagesEnum.PRE_SELECTION,
  editados: JobStagesEnum.EDITED,
  aprovados: JobStagesEnum.APPROVED,
};

export const JobStagesPostCastingEnum = omit(JobStagesEnum, "CASTING");

export const JobStagesTranslate: Record<JobStagesEnum, string> = {
  [JobStagesEnum.CASTING]: "Casting",
  [JobStagesEnum.PRE_SELECTION]: "Pré-Seleção",
  [JobStagesEnum.EDITED]: "Editados",
  [JobStagesEnum.APPROVED]: "Aprovado",
};

export enum JobTypeEnum {
  COMMERCIAL_FILM = "FILME_PUBLICITARIO",
  FEATURE_FILM = "LONGA_METRAGEM",
  SHORT_FILM = "CURTA_METRAGEM",
  DOCUMENTARY = "DOCUMENTARIO",
  SERIES = "SERIE",
  PHOTO = "FOTO",
  FASHION_SHOW = "DESFILADA",
  EVENT = "EVENTO",
}

export const JobTypeTranslate: Record<JobTypeEnum, string> = {
  [JobTypeEnum.COMMERCIAL_FILM]: "Filme publicitário",
  [JobTypeEnum.FEATURE_FILM]: "Longa metragem",
  [JobTypeEnum.SHORT_FILM]: "Curta metragem",
  [JobTypeEnum.DOCUMENTARY]: "Documentário",
  [JobTypeEnum.SERIES]: "Série",
  [JobTypeEnum.PHOTO]: "Foto",
  [JobTypeEnum.FASHION_SHOW]: "Desfilada",
  [JobTypeEnum.EVENT]: "Evento",
};

export enum BroadcastEnum {
  PERIOD = "PERIODO",
  TERRITORY = "TERRITORIO",
  EXCLUSIVITY = "EXCLUSIVIDADE",
  MEDIA = "MIDIAS",
}

export const BroadcastTranslate: Record<BroadcastEnum, string> = {
  [BroadcastEnum.PERIOD]: "Período",
  [BroadcastEnum.TERRITORY]: "Território",
  [BroadcastEnum.EXCLUSIVITY]: "Exclusividade",
  [BroadcastEnum.MEDIA]: "Mídias",
};

// Helpers para gerar opções de select
export const getCastingTeamOptions = () =>
  Object.values(CastingTeam).map((value) => ({
    label: CastingTeamTranslate[value],
    value,
  }));

export const getJobTypeOptions = () =>
  Object.values(JobTypeEnum).map((value) => ({
    label: JobTypeTranslate[value],
    value,
  }));

export const getBroadcastOptions = () =>
  Object.values(BroadcastEnum).map((value) => ({
    label: BroadcastTranslate[value],
    value,
  }));
